import { REACT_APP_API_ABM_FW } from '../../config'
import axios from 'axios'

export async function getExistUser(email) {
    try {
        if(!email) throw Error('field email is required')
        const { data } = await axios.get(`${REACT_APP_API_ABM_FW}/users/email/${email}`);
        return data.data.email;
    } catch (error) {
        console.log(`Error getExistUser `, error)
        return error;   
    }
}